export default __webpack_public_path__ + "static/media/lauryn.d9bb8a7d.png";